import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import PatientInformation from './PatientInformation';
import ContactInformation from './ContactInformation';
import InsuranceInformation from './InsuranceInformation';
import CreditCards from './CreditCards';
import ReferralSource from './ReferralSource';
import SalesRepresentatives from './SalesRepresentatives';
import Prescribers from './Prescribers';
import Vitals from './Vitals';
import Diagnoses from './Diagnoses';
import Notes from './Notes';
import Documents from './Documents';

const PatientProfile = ({
  patient,
  editPatientInformation,
  variant,
  onCreate,
  onCancel,
  hash,
  business,
}) => (
  <Grid
    container
    spacing={16}
    justify="center"
  >
    <Grid
      item
      xs={12}
      md={variant === 'edit' ? 7 : 12}
    >
      {(variant === 'create' || (variant === 'edit' && editPatientInformation) || '#patient-information' === hash) && (
        <PatientInformation
          patient={patient}
          variant={variant}
          onCreate={onCreate}
          onCancel={onCancel}
        />
      )}
      {variant === 'edit' &&
        <Fragment>
          <ContactInformation
            patient={patient}
            {...hash && ['#contact-information', '#address-information'].indexOf(hash) !== -1 ? {
              hash,
            } : {}}
          />
          <InsuranceInformation patient={patient} />
          <CreditCards patient={patient} />
          <Prescribers patient={patient} />
          <ReferralSource patient={patient} />
          <SalesRepresentatives patient={patient} />       
          <Vitals patient={patient} business={business} />
          <Diagnoses patient={patient} business={business} />
        </Fragment>
      }
    </Grid>
    {variant === 'edit' &&
      <Grid item xs={12} md={5}>
        <Notes patient={patient} business={business} />
        <Documents patient={patient} business={business} />
      </Grid>
    }
  </Grid>
);

PatientProfile.propTypes = {
  patient: PropTypes.shape({
    name: PropTypes.string,
  }),
  create: PropTypes.bool,
  variant: PropTypes.oneOf(['create', 'edit']),
  onCreate: PropTypes.func,
  onCancel: PropTypes.func,
  editPatientInformation: PropTypes.bool,
  hash: PropTypes.string,
  business: PropTypes.shape({
    ID: PropTypes.number,
  }),
};

PatientProfile.defaultProps = {
  patient: null,
  create: false,
  variant: 'edit',
  onCreate: null,
  onCancel: null,
  editPatientInformation: false,
  hash: null,
  business: {},
};

export default PatientProfile;



// WEBPACK FOOTER //
// ./src/components/patient/PatientProfile/PatientProfile.js